var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.71429C0 1.25963 0.180612 0.823594 0.502103 0.502103C0.823593 0.180612 1.25963 0 1.71429 0H22.2857C22.7404 0 23.1764 0.180612 23.4979 0.502103C23.8194 0.823594 24 1.25963 24 1.71429C24 2.16894 23.8194 2.60498 23.4979 2.92647C23.1764 3.24796 22.7404 3.42857 22.2857 3.42857H1.71429C1.25963 3.42857 0.823593 3.24796 0.502103 2.92647C0.180612 2.60498 0 2.16894 0 1.71429Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.2856C0 9.83092 0.180612 9.39488 0.502103 9.07339C0.823593 8.7519 1.25963 8.57129 1.71429 8.57129H22.2857C22.7404 8.57129 23.1764 8.7519 23.4979 9.07339C23.8194 9.39488 24 9.83092 24 10.2856C24 10.7402 23.8194 11.1763 23.4979 11.4978C23.1764 11.8192 22.7404 11.9999 22.2857 11.9999H1.71429C1.25963 11.9999 0.823593 11.8192 0.502103 11.4978C0.180612 11.1763 0 10.7402 0 10.2856Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.8574C0 18.4027 0.180612 17.9667 0.502103 17.6452C0.823593 17.3237 1.25963 17.1431 1.71429 17.1431H22.2857C22.7404 17.1431 23.1764 17.3237 23.4979 17.6452C23.8194 17.9667 24 18.4027 24 18.8574C24 19.312 23.8194 19.748 23.4979 20.0695C23.1764 20.391 22.7404 20.5716 22.2857 20.5716H1.71429C1.25963 20.5716 0.823593 20.391 0.502103 20.0695C0.180612 19.748 0 19.312 0 18.8574Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.07e0017658ed5cfe6c2942bb89eaa1e2.svg";
export { ForwardRef as ReactComponent };